/**
 * Виды табов в модальном окне модерации участника тестирования
 */
export const enum EModerateParticipantTabsKeys {
  Approve = 'approve',
  Reject = 'reject',
}
